




































import { defineComponent, PropType, toRefs, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import BehaviorCreator from './index';
import Container from '@/components/common/behavior-container/index.vue';
import { useBehaviorData, useBehaviorOptions, useValidateBehavior } from './../../../hooks/creation/adgroup/useBehavior/index';
import { useAdgroupTargetValidate } from '@tt4b/ttam-hooks';

const name = 'ttam-behavior-creator-compose';
export default defineComponent({
  name,
  components: {
    Container,
    TtamBehaviorCreatorActions: BehaviorCreator.TtamBehaviorCreatorActions,
    TtamBehaviorCreatorCategory: BehaviorCreator.TtamBehaviorCreatorCategory,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData } = toRefs(props);
    const { contentVisible, hasOperated, title, desc } = BehaviorCreator.useContainerProps({
      adgroupData,
    });

    const { creatorActions, creatorCategories, creatorData, getChangedBehaviorData, getClearDataByType } =
      useBehaviorData({
        adgroupData,
      });

    const { actionsEle, categoriesEle, validate } = useValidateBehavior();

    const { behaviorCreatorValidator } = useAdgroupTargetValidate();

    const { creatorBehaviorList: categories } = useBehaviorOptions({
      campaignData,
      adgroupData,
    });

    const selectedActions = computed({
      get: () => creatorActions.value,
      set: val => {
        const data = getChangedBehaviorData({ ...creatorData.value, actions: val }, 'creator');
        validate();
        emit('change', data);
      },
    });

    const selectedCategories = computed({
      get: () => creatorCategories.value,
      set: val => {
        const data = getChangedBehaviorData({ ...creatorData.value, categories: val }, 'creator');
        validate();
        emit('change', data);
      },
    });

    function onRemoveAll() {
      const clearData = getClearDataByType('creator');
      validate();
      emit('change', clearData);
    }

    return {
      name,
      contentVisible,
      hasOperated,
      title,
      desc,
      categories,
      selectedActions,
      selectedCategories,
      behaviorCreatorValidator,
      actionsEle,
      categoriesEle,
      onRemoveAll,
    };
  },
});
